import { CommonModule } from "@angular/common";
import { LimitarAnoDirective } from "./directives/limitar-ano.directive";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MDBBootstrapModulesPro, ToastModule } from "ng-uikit-pro-standard";
import { IConfig, NgxMaskModule } from "ngx-mask";

import { NgxPaginationModule } from "ngx-pagination";
import { HomeComponent } from "./pages/home/home.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { FooterComponent } from "./components/footer/footer.component";
import { CognitoService } from "./services/cognito.service";
import { ListaInstituicoesRegimeComponent } from './pages/home/lista-instituicoes-regime/lista-instituicoes-regime.component';
import { AppRoutingModule } from "src/app/core/app-routing.module";
import { ModalBloqueadorComponent } from './components/modal-bloqueador/modal-bloqueador.component';
import { TokenInputComponent } from './components/token-input/token-input.component';
// import { CurrencyMaskModule } from "ng2-currency-mask";

export const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [HomeComponent, NavbarComponent, FooterComponent, ListaInstituicoesRegimeComponent, ModalBloqueadorComponent, TokenInputComponent, LimitarAnoDirective],
  exports: [
    MDBBootstrapModulesPro,
    NgxPaginationModule,
    NgxMaskModule,
    FooterComponent,
    NavbarComponent,
    ModalBloqueadorComponent,
    TokenInputComponent,
    LimitarAnoDirective,
  ],
  imports: [
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    MDBBootstrapModulesPro.forRoot(),
    NgxMaskModule.forRoot(),
    AppRoutingModule
],
  entryComponents: [],
  providers: [CognitoService],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SharedModule {}
